export default __webpack_public_path__ + "static/media/user.03f03739.svg";